import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';
import { getAlertTypeFilterOptions } from '../../../lib/utils/alertLabels';

const AlertsSearchFilters = ({
  candidateSearch,
  onCandidateSearchChange,
  dateFilter,
  onDateFilterChange,
  alertType,
  onAlertTypeChange,
  totalAlerts,
}) => {
  const { t, i18n } = useTranslation();
  const typeOptions = useMemo(() => getAlertTypeFilterOptions(), [i18n.language]);

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 mb-6">
      <div className="flex flex-col lg:flex-row gap-4 lg:gap-6 lg:items-end">
        <div className="flex-1">
          <Input
            label={t('alerts.searchLabel')}
            type="search"
            placeholder={t('alerts.searchPlaceholder')}
            value={candidateSearch}
            onChange={(event) => onCandidateSearchChange(event?.target?.value ?? '')}
            className="w-full"
          />
        </div>

        <div className="w-full lg:w-64">
          <Input
            label={t('alerts.filterDate')}
            type="date"
            value={dateFilter}
            onChange={(event) => onDateFilterChange(event?.target?.value ?? '')}
            className="w-full"
          />
        </div>

        <div className="w-full lg:w-64">
          <Select
            label={t('alerts.filterType')}
            options={typeOptions}
            value={alertType}
            onChange={onAlertTypeChange}
            placeholder={t('alerts.selectType')}
          />
        </div>

        <div className="flex items-center gap-2 text-sm text-muted-foreground bg-muted px-4 py-3 rounded-lg whitespace-nowrap">
          <Icon name="Bell" size={16} />
          <span className="font-medium">{t('alerts.totalAlerts', { count: totalAlerts })}</span>
        </div>
      </div>
    </div>
  );
};

export default AlertsSearchFilters;
